import SchoolIcon from '@mui/icons-material/School'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'

export const routeBackOfficeStudentAdminCommon = [
  {
    route: 'HistoryOrders',
    menuGroup: MENU_GROUPS.MONITORING,
    text: 'Gestion des commandes',
    icon: ShoppingCartIcon,
    href: '/backoffice/insight/order',
    menuHeader: true,
    position: 200,
  },
  {
    route: 'DetailOrder',
    text: 'Détails des commandes',
    href: '/backoffice/insight/order/detail-order/[orderId]',
  },
  {
    route: 'UserStudentList',
    menuGroup: MENU_GROUPS.DIRECTORY,
    text: 'Liste des étudiants',
    icon: SchoolIcon,
    href: '/backoffice/group/user-student/user-student-list',
    menuHeader: true,
    position: 150,
    isMobile: true,
  },
  {
    route: 'StudentUserAdd',
    text: 'Ajouter un étudiant',
    href: '/backoffice/group/user-student/add-user-student',
    menuHeader: false,
  },
  {
    route: 'StudentUserEdit',
    text: 'Editer un étudiant',
    href: '/backoffice/group/user-student/edit-user-student/[userId]',
    menuHeader: false,
  },
]
